/**
 * Subject-color helpers: readable text color + soft background derivation
 * from an arbitrary hex.
 */

function hexToRgb(hex) {
  if (!hex) return [136, 136, 136];
  const v = String(hex).replace("#", "");
  if (v.length !== 6 && v.length !== 3) return [136, 136, 136];
  const n = parseInt(v.length === 3 ? v.split("").map((c) => c + c).join("") : v, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

// WCAG relative luminance (0..1). Lower = darker.
export function relativeLuminance(hex) {
  const [r, g, b] = hexToRgb(hex).map((v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/**
 * Returns a text color for a subject "chip"/name label:
 * - If subject color is dark enough, use the subject color itself
 * - Otherwise, use a darkened version (via color-mix in the caller isn't easy
 *   here since we return a string), so fall back to `var(--text)`.
 */
export function textColorForSubject(hex) {
  if (!hex) return "var(--text)";
  const lum = relativeLuminance(hex);
  // Threshold picked so pastel/sakura palette colours (all lum > 0.5) fall to
  // --text, while bolder brand hues render coloured.
  return lum < 0.55 ? hex : "var(--text)";
}
